import { render, staticRenderFns } from "./icstatus.vue?vue&type=template&id=2a0e29e2&scoped=true"
import script from "./icstatus.vue?vue&type=script&lang=js"
export * from "./icstatus.vue?vue&type=script&lang=js"
import style0 from "./icstatus.vue?vue&type=style&index=0&id=2a0e29e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a0e29e2",
  null
  
)

export default component.exports